import { isUuid } from '../utils';

// The shared base declares no `window`. Read it off `globalThis` at call time: it is undefined in Node, and tests stub it.
const browserGlobals = globalThis as { window?: { location: { host: string; pathname: string } } };

const getHostName = (): string => browserGlobals.window?.location.host ?? '';

export const isProductionEnvironment = (): boolean => {
    // oxlint-disable-next-line no-undef -- Vite substitutes process.env.* in the browser build (`define` in vite.config.ts); Node reads the real one
    if (process.env.REACT_APP_PRETEND_TO_BE_IN_PRODUCTION === 'true') {
        return true;
    }
    const hostName = getHostName();
    if (hostName.endsWith('.dev.luminovo.ai')) {
        return false;
    }
    // oxlint-disable-next-line no-undef -- Vite substitutes process.env.* in the browser build (`define` in vite.config.ts); Node reads the real one
    if (process.env.NODE_ENV === 'production') {
        return true;
    }
    // oxlint-disable-next-line no-undef -- Vite substitutes process.env.* in the browser build (`define` in vite.config.ts); Node reads the real one
    if (process.env.NODE_ENV === 'development') {
        return false;
    }
    if (hostName.includes('chromatic.com')) {
        return false;
    }
    if (hostName.includes('localhost')) {
        return false;
    }

    // No hostname: a local Node run or test (deployed services set NODE_ENV), so `throwErrorUnlessProduction` throws.
    if (hostName === '') {
        return false;
    }

    // An unrecognised hostname is assumed to be production.
    return true;
};

const trailEnvironments = [
    'mint.luminovo',
    'ruby.luminovo',
    'peach.luminovo',
    'coral.luminovo',
    'bronze.luminovo',
    'olive.luminovo',
    'navy.luminovo',
    'gray.luminovo',
    'lime.luminovo',
    'silver.luminovo',
    'crystal.luminovo',
    'gold.luminovo',
    'green.luminovo',
    'white.luminovo',
    'pink.luminovo',
    'yellow.luminovo',
    'red.luminovo',
    'purple.luminovo',
    'orange.luminovo',
    'blue.luminovo',
];

/** Neither production nor development: https://www.notion.so/luminovo/61f4d1d942b144368b2988e3311acad5 */
export const isTrailEnvironment = (): boolean => {
    const hostName = getHostName();
    return trailEnvironments.some((host) => hostName.startsWith(host));
};

/** Replaces UUIDs in the pathname with `:`, so errors on the same route group together in Sentry. */
export const normalizePathname = (): string => {
    const window = browserGlobals.window;
    if (window === undefined) return '';
    return window.location.pathname
        .split('/')
        .map((part) => (isUuid(part) ? ':' : part))
        .join('/');
};
